import BaseModel from '../core/BaseModel'
export default class RolePermissionModel extends BaseModel {
    constructor() {
        super({ 
                name: "role_permission",
                tableName: 'core_role_permission'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}